import React from 'react';
import { Shield, Twitter, Linkedin, Github } from 'lucide-react';
export function Footer() {
  return <footer className="bg-[#050b14] border-t border-slate-800 pt-16 pb-8 relative overflow-hidden" data-id="element-54">
      {/* Grid Pattern */}
      <div className="absolute inset-0 bg-grid-pattern opacity-5 pointer-events-none" data-id="element-55" />

      <div className="container mx-auto px-4 relative z-10" data-id="element-56">
        <div className="grid md:grid-cols-4 gap-12 mb-12" data-id="element-57">
          <div className="col-span-1 md:col-span-2" data-id="element-58">
            <div className="flex items-center gap-2 mb-6" data-id="element-59">
              <Shield className="w-8 h-8 text-[#00d4ff]" data-id="element-60" />
              <span className="text-2xl font-bold text-white tracking-tight" data-id="element-61">
                ECLATGAME
              </span>
            </div>
            <p className="text-slate-400 max-w-sm mb-6" data-id="element-62">
              Advanced competitive intelligence for the modern digital
              battlefield. Secure your market position with data-driven
              strategy.
            </p>
            <div className="flex gap-4" data-id="element-63">
              <a href="#" className="text-slate-500 hover:text-[#00d4ff] transition-colors" data-id="element-64">
                <Twitter className="w-5 h-5" data-id="element-65" />
              </a>
              <a href="#" className="text-slate-500 hover:text-[#00d4ff] transition-colors" data-id="element-66">
                <Linkedin className="w-5 h-5" data-id="element-67" />
              </a>
              <a href="#" className="text-slate-500 hover:text-[#00d4ff] transition-colors" data-id="element-68">
                <Github className="w-5 h-5" data-id="element-69" />
              </a>
            </div>
          </div>

          <div data-id="element-70">
            <h4 className="text-white font-bold mb-4 font-mono uppercase text-sm" data-id="element-71">
              Headquarters
            </h4>
            <address className="text-slate-400 not-italic text-sm space-y-2" data-id="element-72">
              <p data-id="element-73">ul. Marszałkowska 142</p>
              <p data-id="element-74">00-061 Warszawa</p>
              <p data-id="element-75">Poland</p>
            </address>
          </div>

          <div data-id="element-76">
            <h4 className="text-white font-bold mb-4 font-mono uppercase text-sm" data-id="element-77">
              System
            </h4>
            <ul className="space-y-2 text-sm text-slate-400" data-id="element-78">
              <li data-id="element-79">
                <a href="#" className="hover:text-[#00d4ff] transition-colors" data-id="element-80">
                  Login
                </a>
              </li>
              <li data-id="element-81">
                <a href="#" className="hover:text-[#00d4ff] transition-colors" data-id="element-82">
                  API Status
                </a>
              </li>
              <li data-id="element-83">
                <a href="#" className="hover:text-[#00d4ff] transition-colors" data-id="element-84">
                  Documentation
                </a>
              </li>
              <li data-id="element-85">
                <a href="#" className="hover:text-[#00d4ff] transition-colors" data-id="element-86">
                  Security Protocol
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-slate-800 pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-slate-600 font-mono" data-id="element-87">
          <p data-id="element-88">© 2026 Eclatgame. All rights reserved.</p>
          <div className="flex gap-6" data-id="element-89">
            <a href="#" className="hover:text-slate-400" data-id="element-90">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-slate-400" data-id="element-91">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>;
}